exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".default-layout{background-color:#fff;color:#636b6f;font-weight:100;height:100vh;margin:0}.default-layout .links>a{color:#636b6f;padding:0 25px;font-size:12px;font-weight:600;letter-spacing:.1rem;text-decoration:none;text-transform:uppercase}", ""]);

// exports
